module.exports = __webpack_public_path__ + "img/OnArchitecture2.b32d3ea2.jpg";